import Vue from 'vue';
import router from '@/router';

import { initialize as initializeSdk, Localization, utils } from '@easygenerator/fragment-sdk';
import { FragmentsServiceFactory } from '@easygenerator/client-sdk.fragments';
import { FragmentsLoaderProvider, ModuleName } from '@easygenerator/client-sdk.common';

import App from '@/App.vue';
import { SUPPORTED_LANGS } from './utils/constants';
import Config from '@/config';
import { getLocaleAndDir } from './utils/locale';

Vue.config.productionTip = false;

const translationManager = utils.TranslationManager.getInstance();

Vue.use(Localization);

const urlParams = new URLSearchParams(window.location.search);

const { locale, dirAttribute } = getLocaleAndDir(urlParams);

document.body.setAttribute('dir', dirAttribute);

function initializeGlobalVariables(config: Config) {
  window.discoveryServiceUrl = config.discoveryServiceUrl;
}

(async () => {
  const config = Config.getInstance();
  await config.initialize();
  initializeGlobalVariables(config);

  FragmentsServiceFactory.initialize();

  const UiKit = await FragmentsLoaderProvider.fragmentsLoader.loadModule(ModuleName.uiKit);
  Vue.use(UiKit);

  await Promise.all([
    translationManager.initialize({
      path: '/localization/lang',
      supportedLangs: SUPPORTED_LANGS,
      locale
    })
  ]);

  await initializeSdk({ localize: translationManager.localize, initializePermissions: false });

  Vue.use(Localization);
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app');
})();
